import React, {Fragment} from "react";
import Select from "../components/form/Select";
import DateTimeInput from "../components/form/DateTimeInput";
import {ComponentOptions} from "./formatters";
import PeriodInput from "../components/form/PeriodInput";
import {get} from "./dotutils";

export const priorityFilter = () => {
    return <Select
        isClearable={true}
        optionname="priority_value"
        objectValue={false}
        storeType="local"
        label={false}
    />;
}

export const booleanFilter = () => {
    return <Select
        isClearable={true}
        options={[{value: '1  ', label: 'Igen'},{value: '0  ', label: 'Nem'}]}
        objectValue={false}
        storeType="local"
        label={false}
        valueKey="value"
        labelKey="label"
    />;
}

export const activeFilter = () => {
    return <Select
        isClearable={true}
        options={[{value: '1  ', label: 'Aktív'},{value: '0  ', label: 'Inaktív'}]}
        objectValue={false}
        storeType="local"
        label={false}
        valueKey="value"
        labelKey="label"
    />;
}

export const optionFilter = (optionname) => {
    return <Select
        isClearable={true}
        objectValue={false}
        optionname={optionname}
        storeType="local"
        focus={true}
        label={false}
    />;
}

export const componentFilter = ({component = null, labelfield = null, valuefield = null, props = {}}) => {
    if (Array.isArray(component)) {
        return <Select
            storeType="local"
            options={component.length ? component : ComponentOptions}
            label={false}
            objectValue={false}
            isClearable={true}
            valueKey={valuefield || "key"}
            labelKey={labelfield || "label"}
            {...props}
        />;
    } else {
        return <Select
            storeType="local"
            label={false}
            component={component}
            labelKey={labelfield}
            valueKey={valuefield}
            objectValue={false}
            isClearable={true}
            {...props}
        />;
    }
}

class DateExpertFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: get(props, "filter.value")
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (get(this.props, "filter.value") !== get(prevProps, "filter.value")) {
            this.setState({value: get(this.props, "filter.value")});
        }
    }

    render() {
        const props = this.props;
        let filter = props.filter || {field: props.name, value: null};
        let operator = filter.operator || "LIKE";
        let value = this.state.value;
        if (!Array.isArray(value) && value) {
            if (filter.operator === "<") {
                value = [null, value];
            } else if (filter.operator === ">") {
                value = [value, null];
            }
        }
        return <Fragment>
            <PeriodInput
                label={false}
                period={false}
                year={false}
                inline={false}
                periodChangeType="default"
                value={value}
                saveChanges={(field, value) => {
                    value = value.map((date, i) => date ? (i === 0 ? (date.indexOf(":") === -1 ? date + " 00:00:00" : date) : (date.indexOf(":") === -1 ? date + " 23:59:59" : date)) : date);
                    if (value[0] && value[1]) {
                        operator = "between";
                    } else if (value[1]) {
                        operator = "<";
                        value = value[1];
                    } else if (value[0]) {
                        operator = ">";
                        value = value[0];
                    } else {
                        value = null;
                    }
                    if (value) {
                        props.onFilter({...filter, value, operator});
                    } else {
                        props.onFilter(null);
                    }
                }}
            />
        </Fragment>
    }
}

DateExpertFilter.expertFilter = true;

export const dateFilter = ({period = false} = {}) => {
    if (period) {
        return <DateExpertFilter />
    } else {
        return <DateTimeInput label={false} isClearable={true}/>
    }
}

export const localOptionFilter = (options, key = "key", label = "label") => {
    return <Select
        storeType="local"
        options={options}
        label={false}
        objectValue={false}
        isClearable={true}
        valueKey={key}
        labelKey={label}
    />
}